import {useParams} from "react-router-dom";
import * as UserService from "../../api/UserService";
import React, {useEffect, useState} from "react";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import pageStyle from "./GameComments.module.css"
import {Form} from "react-bootstrap";
import InstagramWarning from "../InstagramWarning";
import {useTranslation} from "react-i18next";

function GameComments(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'gameComments' });
    const params = useParams()
    const [gameState, setGameState] = useState()
    const [cards, setCards] = useState()
    const [steps, setSteps] = useState([])
    const [gameSuccessfullyFetched, setGameSuccessfullyFetched] = useState(undefined)
    const [hideEmptySteps, setHideEmptySteps] = useState(false)
    const [textFormat, setTextFormat] = useState(false)
    const [tableFormat, setTableFormat] = useState(true)
    const [loggedIn, setLoggedIn] = useState(undefined)

    function callGameState() {
        UserService.getCurrentGame(params.game_id, (state) => {
            setGameState(state)
            setSteps(state.steps.reverse())
            setGameSuccessfullyFetched(true)
        }, (response) => {
            if (response.status === 404) {
                setGameSuccessfullyFetched(false)
            } else {
                window.alert(t('error'))
            }

        })
    }

    function resolveDice(step) {
        if (["regular", "no_move_enter", "on_finish_position", "no_move_over",
            "no_move_68_check_3x6_rule", "3x6_rule", "on_finish_position"].includes(step.player_move_type)) {
            return step.dice_number
        } else if (step.player_move_type === "arrow") {
            return t('arrow')
        } else if (step.player_move_type === "snake") {
            return t('snake')
        } else if (step.player_move_type === "hand_move") {
            return t('toEarth')
        } else {
            return t('unknown')
        }
    }

    function pullCards() {
        UserService.getAllMentorCardsByGameId(params.game_id, (state) => {
                state.unshift({
                    title: t('requestPrep')
                })
                setCards(state)
                UserService.verifyLogin(setLoggedIn)
            }
            ,
            () => setGameSuccessfullyFetched(false))
    }

    useEffectOnce(() => {
        pullCards()
    }, []);

    useEffect(() => {
        if (loggedIn === true || loggedIn === false) {
            callGameState()
        }
    }, [loggedIn])

    function resolveHideEmptySteps() {
        setHideEmptySteps(!hideEmptySteps)
    }

    function resolveTextFormat() {
        setTextFormat(!textFormat)
        setTableFormat(!tableFormat)
    }

    return (
        <>
            <InstagramWarning/>
            <div className={pageStyle.commentsOwner}>
                {t('comments')} {loggedIn ? t('hosts') : t('player') + gameState?.player_name}</div>
            <div className={pageStyle.commentsOwner}>
                {t('theSameLinkOpens')} {loggedIn ? t('player1') : t('host')} - {t('hisComments')}</div>
            <Form>
                <Form.Check
                    style={{
                        marginLeft: "12px",
                    }}
                    checked={hideEmptySteps}
                    id={"personal_game"}
                    type="switch"
                    onChange={e => resolveHideEmptySteps()}
                    label={<b>{t('hideNoCommentsSteps')}</b>}
                />
            </Form>
            <Form>
                <Form.Check
                    style={{
                        marginLeft: "12px",
                    }}
                    checked={textFormat}
                    id={"personal_game"}
                    type="switch"
                    onChange={resolveTextFormat}
                    label={<b>{t('asText')}</b>}
                />
            </Form>
            <Form>
                <Form.Check
                    style={{
                        marginLeft: "12px",
                    }}
                    checked={tableFormat}
                    id={"personal_game"}
                    type="switch"
                    onChange={resolveTextFormat}
                    label={<b>{t('asTable')}</b>}
                />
            </Form>
            <div className={pageStyle.head}>
                <div><b>{t('gameName')}</b> {gameState?.name}</div>
                <div><b>{t('playerName')}</b> {gameState?.player_name}</div>
                <div><b>{t('playerRequest')}</b> {gameState?.user_request}</div>
                <div><b>{t('playerPos')}</b> {gameState?.current_user_position}</div>
            </div>

            {
                tableFormat &&
                <table className={pageStyle.table}>
                    <tr>
                        <th>{t('fromPos')}</th>
                        <th>{t('dice')}</th>
                        <th>{t('toPos')}</th>
                        <th>{t('comment')}</th>
                    </tr>
                    {
                        steps.map((step) => {
                            if (hideEmptySteps) {
                                if (step?.comment !== null && step?.type !== "metaphoric_card") {
                                    return (
                                        <tr>
                                            <th>{step?.from_position} - {cards[step?.from_position]?.title}</th>
                                            <th>{resolveDice(step)}</th>
                                            <th>{step?.to_position} - {cards[step?.to_position]?.title}</th>
                                            <th>{step?.comment === null ? "-" : step?.comment}</th>
                                        </tr>
                                    )
                                }
                            } else {
                                if (step?.type !== "metaphoric_card") {
                                    return (
                                        <tr>
                                            <th>{step?.from_position} - {cards[step?.from_position]?.title}</th>
                                            <th>{resolveDice(step)}</th>
                                            <th>{step?.to_position} - {cards[step?.to_position]?.title}</th>
                                            <th>{step?.comment === null ? "-" : step?.comment}</th>
                                        </tr>
                                    )
                                }
                            }
                        })
                    }
                </table>
            }
            {
                textFormat &&
                <div>
                    <div>===============================================</div>
                    {
                        steps.map((step) => {
                            if (hideEmptySteps) {
                                if (step?.comment !== null && step?.type !== "metaphoric_card") {
                                    return (
                                        <div className={pageStyle.freeText}>
                                            <div>[{step?.from_position}:{cards[step?.from_position]?.title} → {resolveDice(step)} → {step?.to_position}:{cards[step?.to_position]?.title}]</div>
                                            <div>{step?.comment === null ? "-" : step?.comment}</div>
                                            <div>===============================================</div>
                                        </div>
                                    )
                                }
                            } else {
                                if (step?.type !== "metaphoric_card") {
                                    return (
                                        <div className={pageStyle.freeText}>
                                            <div>[{step?.from_position}:{cards[step?.from_position]?.title} → {resolveDice(step)} → {step?.to_position}:{cards[step?.to_position]?.title}]</div>
                                            <div>{step?.comment === null ? "-" : step?.comment}</div>
                                            <div>===============================================</div>
                                        </div>
                                    )
                                }
                            }
                        })
                    }

                </div>
            }

        </>
    )
}

export default GameComments;